import { Box, styled, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

const PREFIX = 'TSMED-ControlPanel';

export const controlPanelClasses = {
  root: `${PREFIX}-root`,
  button: `${PREFIX}-button`,
  icon: `${PREFIX}-icon`,
  aircraft: `${PREFIX}-aircraft`,
};

interface MapControlPanelProps {
  direction?: 'row' | 'column';
  className?: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const Root = styled(Box)(
  ({ theme: { palette, spacing, shadows, breakpoints } }) => ({
    [`&.${controlPanelClasses.root}`]: {
      backgroundColor: palette.mapBlue[700],
      border: `2px solid ${palette.mapBlue[600]}`,
      borderRadius: spacing(1.5),
      display: 'flex',
      boxShadow: shadows[3],
      boxSizing: 'border-box',
      width: spacing(5),
      alignItems: 'center',

      [breakpoints.down('lg')]: {
        width: spacing(4),
      },

      '&[data-direction="row"]': {
        flexDirection: 'row',
        width: 'auto',
      },

      '&[data-direction="column"]': {
        flexDirection: 'column',
      },

      [`.${controlPanelClasses.button}`]: {
        color: palette.common.white,
        borderRadius: 0,
        width: spacing(5),
        height: spacing(5),
        padding: 0,
        boxSizing: 'border-box',
        '&:disabled': {
          opacity: 0.3,
        },

        [breakpoints.down('lg')]: {
          width: spacing(4),
          height: spacing(4),
        },
      },

      [`&[data-direction="row"] .${controlPanelClasses.button}:not(:last-of-type)`]:
        {
          borderRight: `2px solid ${palette.mapBlue[600]}`,
        },

      [`&[data-direction="column"] .${controlPanelClasses.button}:not(:last-of-type)`]:
        {
          borderBottom: `2px solid ${palette.mapBlue[600]}`,
        },

      [`.${controlPanelClasses.icon}`]: {
        display: 'block',
        width: spacing(3),
        height: spacing(3),

        [breakpoints.down('lg')]: {
          width: spacing(2.5),
          height: spacing(2.5),
        },
      },

      [`.${controlPanelClasses.icon}.${controlPanelClasses.aircraft}`]: {
        transform: 'rotate(-90deg)',
        transformOrigin: 'center center',
      },

      [`.${controlPanelClasses.icon} path, .${controlPanelClasses.icon} rect, .${controlPanelClasses.icon} circle`]:
        {
          fill: palette.mapBlue[300],
        },

      [`.${controlPanelClasses.icon}[data-active="true"] path, 
      .${controlPanelClasses.icon}[data-active="true"] rect, 
      .${controlPanelClasses.icon}[data-active="true"] circle`]: {
        fill: palette.common.white,
      },
    },
  }),
);

export const MapControlPanel = ({
  direction = 'row',
  className,
  children,
  sx,
}: MapControlPanelProps) => (
  <Root
    sx={sx}
    className={`${controlPanelClasses.root} ${className ?? ''}`}
    data-direction={direction}
  >
    {children}
  </Root>
);
